module Sm.UI.Heatmap

open System

open Fable.DateFunctions

open Sm.Core.Numeric
open Sm.Core.Option

open Sm.Service.Tracking

type Value = 
    {
        Intensity: float
        Bias: float
    }
    static member Zero = { Intensity = 0.; Bias = 0. }

type Cell = {
    IsNow: bool
    InActiveRange: bool
    Value: Value
}

type Heatmap = {
    Label: string
    Highlight: bool
    Rows: int
    Columns: int
    Samples: Map<int, Cell>
}

let activeStart = 9
let activeEnd = 18

let activeHour hour =
    hour >= activeStart && hour < activeEnd

let activeDay = function
    | DayOfWeek.Saturday | DayOfWeek.Sunday -> false
    | _ -> true

let daySegmentFor (time: DateTime) =
    let h = time.Hour
    if h > 17 then [18..23]
    elif h > 11 then [12..17]
    elif h > 5 then [6..11]
    else [0..5]

let bias over under =
    let total = over + under
    if total = 0 || under = 0 then 1.
    else over /. total

let series range sample =
    let max =
        match range with
        | Range.Day _ -> secondsPerDay
        | Range.Hour _ -> secondsPerHour
        | Range.Centile _ -> secondsPerCentile

    Range.start range
    |> Some
    |> Seq.unfold (fun state -> maybe {
        let! s = state

        let seconds = sample s
        let total = seconds.Over + seconds.Under

        let value =
            if total > 0 then
                {
                    Intensity =  total /. max
                    Bias = bias seconds.Over seconds.Under
                }
            else Value.Zero

        return (s, value), Range.tryIncrement s
    })

let hour (date: DateTime) sample =
    let now = DateTime.Now
    let range = Range.centileOf date |> Range.start

    let isActiveDay = activeDay date.DayOfWeek
    let _, _, _, h, _ = range |> Range.unpack
    let isActiveHour = h |> Option.map activeHour |> Option.defaultValue false
    let isActive = isActiveDay && isActiveHour

    {
        Label = sprintf "%02i:00" date.Hour
        Highlight = date.Date = now.Date && date.Hour = now.Hour
        Rows = 6
        Columns = 6
        Samples =
            series range sample
            |> Seq.mapi (fun i (s, value) ->
                let cell = {
                    IsNow = s |> Range.contains now
                    InActiveRange = isActive
                    Value = value 
                }
                i, cell
            )
            |> Map.ofSeq
    }

let hourSeries (now: DateTime) sample =
    let hours = daySegmentFor now

    [
        for h in hours do
            let date = now.SetHours(h)
            sample |> hour date 
    ]
